// HOW TO USE tooltip-clickable
//  - On .html.erb file add once:
//      <tooltip-component></tooltip-component>
//  - And wherever tooltip is required:
//      div class="tooltip-clickable">
//        This is a CLICKABLE tooltip sample text
//      </div>

$(document).ready(function(e){
  let tooltip_template = $("#tooltip-template")

  $(".tooltip-clickable").each(function(idx){
    let tooltip_template_instance = tooltip_template.find(".tooltip-container").clone()
    let tp_component = $(this)
    let content = $(this).html()
    tooltip_template_instance.find(".tp-content").html(content)
    tooltip_template_instance.find(".tp-cursor").click(function(e){
      let tp_content = tooltip_template_instance.find(".tp-content")
      tp_content.toggle()
    })
    $(this).html(tooltip_template_instance)
  })
})
